{
  "api": {
    "locationValidationTitle": "Nous n'avons pas pu valider votre localisation",
    "thresholdTitle": "Vous n'êtes pas à l'heure pour vous enregistrer",
    "warehouseUnavailableTitle": "Entrepôt non disponible",
    "warehouseUnavailableMessage": "Veuillez contacter le personnel de l'établissement pour procéder à l'enregistrement manuel",
    "characterLimitTitle": "La saisie dépasse la limite de caractères",
    "genericTitle": "L'enregistrement a échoué. Veuillez réessayer.",
    "recaptchaTitle": "Échec de la vérification",
    "recaptchaMessage": "Nous n'avons pas pu vérifier votre demande. Veuillez réessayer ou contacter le personnel de l'établissement."
  }
}
